export class Action {
  state;
  dispatch;
  constructor({ state, dispatch }) {
    this.state = state;
    this.dispatch = dispatch;
  }
}
